import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FeatureInterface } from '../models';

@Injectable({
  providedIn: 'root',
})
export class FeatureControlRestConnectorService extends RestConnectorService {
  constructor(
    private readonly _httpClient: HttpClient,
    protected readonly _store: Store<AppStateInterface>
  ) {
    super(_store);
  }

  /**
   * Loads all features from the API
   * @returns Observable array of features
   */
  public loadFeatures(): Observable<FeatureInterface[]> {
    return this._httpClient
      .get<FeatureInterface[]>('/api/features', {
        observe: 'response',
      })
      .pipe(
        map((httpResponse: HttpResponse<FeatureInterface[]>) => {
          return httpResponse.body || [];
        })
      );
  }
}
